import { ComprehensiveCompanySearchResponse } from "../../features/api-interfaces";
import { DivisionDict } from "../default-constants";

export const getComprehensiveCompanyItems = (
  companies: ComprehensiveCompanySearchResponse[] | undefined
): DivisionDict[] => {
  if (companies !== undefined) {
    return companies.map((companies) => ({
      label: companies.comprehensiveCompanyName,
      value: companies.comprehensiveCompanyCode,
    }));
  }
  return [];
};
